<div class="svg-tooltip">
    <div class="arrow-left"></div>
    <div class="tooltip-box">
    </div>
</div>
